import { AppProvider } from "@/app/provider";
import { AppRouter } from "@/app/router";
import ErrorBoundary from "@/components/ErrorBoundary";

export const App = () => {
  return (
    <ErrorBoundary>
      <AppProvider>
        <AppRouter />
      </AppProvider>
    </ErrorBoundary>
  );
};
